import React from 'react';
import { Text, Image, makeStyles, tokens, typographyStyles } from '@fluentui/react-components';
import ErrorImg from '../../assets/restricted.svg';

const useStyles = makeStyles({
  errorWrapperOuter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorWrapperInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '100px',
  },
  firstRow: {
    marginTop: tokens.spacingVerticalXXL,
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase600,
    lineHeight: tokens.lineHeightHero700,
  },
  secondRow: {
    marginTop: tokens.spacingVerticalS,
    ...typographyStyles.body2,
  },
});

const ErrorMessage500Component = () => {
  const classes = useStyles();
  return (
    <div className={classes.errorWrapperOuter}>
      <div className={classes.errorWrapperInner}>
        <Image src={ErrorImg} height="200" width="222" />
        <Text className={classes.firstRow}>Service use limits exceeded or service temporarily unavailable.</Text>
        <Text className={classes.secondRow}>Please wait and try your request again in a few minutes.</Text>
      </div>
    </div>
  );
};

export const ErrorMessage500 = ErrorMessage500Component;
